<template>
  <div id="ListMenuToday" class="col s12 m12 xl12 active">
    <ul class="collapsible popout">
      <li>
        <div class="collapsible-header menu_01">
          <div class="center-outer">
            <div class="bubbles">
              <h4>Desayunos</h4>
            </div>
          </div>
        </div>
        <div class="collapsible-body">
          <div class="collection with-header">
            <Item
              v-for="(Obj, key) in ObjBreakfasts"
              v-bind:item="Obj"
              v-bind:index="key"
              v-bind:key="Obj.code"
              v-bind:Obj="Obj"
            />
          </div>
        </div>
      </li>
      <li>
        <div class="collapsible-header menu_02">
          <div class="bubbles">
            <h4>Almuerzos</h4>
          </div>
        </div>
        <div class="collapsible-body">
          <div class="collection with-header">
            <Item
              v-for="(Obj, key) in ObjLunches"
              v-bind:item="Obj"
              v-bind:index="key"
              v-bind:key="Obj.code"
              v-bind:Obj="Obj"
            />
          </div>
        </div>
      </li>
      <li>
        <div class="collapsible-header menu_03">
          <div class="bubbles">
            <h4>Cena</h4>
          </div>
        </div>
        <div class="collapsible-body">
          <div class="collection with-header">
            <Item
              v-for="(Obj, key) in ObjDinners"
              v-bind:item="Obj"
              v-bind:index="key"
              v-bind:key="Obj.code"
              v-bind:Obj="Obj"
              v-bind:cateringId="cateringId"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import moment from "moment";
import BubblesJs from "../../assets/script/bubble.js";
import BubblesCss from "../../assets/style/bubble.css";
import Item from "./ItemMenuToday";
export default {
  name: "ListMenuToday",
  props: ["cateringId"],
  data() {
    moment.locale("es_CO");
    return {
      info_year: moment().format("YYYY"),
      info_month: moment().format("MM"),
      info_day: moment().format("DD"),
      info: moment().format("DD-MM-YYYY"),
      ObjBreakfasts: [
        {
          fecha: "20-01-2019",
          code: 1,
          name: "Tortitas o Pancakes americanos",
          desc_min:
            "Tortitas o pancakes. Desayuno muy abundante, pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          desc_max:
            "Hay pocas cosas más americanas que un desayuno con tortitas o pancakes. Las perfectas escenas familiares se suceden en torno a un desayuno muy abundante, en el que no faltan opciones caseras y potentes que pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          ingredientes:
            "<ul><li>150 gr de harina de trigo.</li><li>1 cucharada sopera de azúcar.</li><li>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li>1 pizca de sal.</li><li>200 ml de leche (1 vaso).</li><li>1 huevo.</li><li>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_1.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 2,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul><li>3 huevos frescos tamaño L.</li><li>2 cucharadas soperas de leche.</li><li>Aceite de semillas y sal.</li><li>4 lonchas de bacon.</li></ul>Para acompañar, tuesta unas rebanadas de tu pan preferido (el mío es de cereales), y exprime unas naranjas.",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 3,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 4,
          name: "Omelette con Espinacas",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "PLato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul><li>4 huevos</li><li>2 tajadas de queso</li><li>1 taza de espinacas</li><li>Mantequilla</li><li>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        }
      ],
      ObjLunches: [
        {
          fecha: "20-01-2019",
          code: 5,
          name: "Tortitas o Pancakes americanos",
          desc_min:
            "Tortitas o pancakes. Desayuno muy abundante, pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          desc_max:
            "Hay pocas cosas más americanas que un desayuno con tortitas o pancakes. Las perfectas escenas familiares se suceden en torno a un desayuno muy abundante, en el que no faltan opciones caseras y potentes que pueden incluir también zumos, café, huevos fritos, tostadas, mermeladas…",
          ingredientes:
            "<ul><li>150 gr de harina de trigo.</li><li>1 cucharada sopera de azúcar.</li><li>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li>1 pizca de sal.</li><li>200 ml de leche (1 vaso).</li><li>1 huevo.</li><li>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_1.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 6,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul><li>3 huevos frescos tamaño L.</li><li>2 cucharadas soperas de leche.</li><li>Aceite de semillas y sal.</li><li>4 lonchas de bacon.</li></ul>Para acompañar, tuesta unas rebanadas de tu pan preferido (el mío es de cereales), y exprime unas naranjas.",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 7,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 8,
          name: "Omelette con Espinacas",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "PLato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul><li>4 huevos</li><li>2 tajadas de queso</li><li>1 taza de espinacas</li><li>Mantequilla</li><li>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        }
      ],
      ObjDinners: [
        {
          fecha: "20-01-2019",
          code: 9,
          name: "Cazuela Cremosa de Pasta y Queso",
          desc_min:
            "Cheesy Creamy Pasta Casserole is as delicious and almost as easy as your traditional mac and cheese! The difference? An additional touch of nutritious vegetables mixed in a variety of melted cheeses. Dare to serve your family something different!",
          desc_max:
            "¡Cheesy Creamy Pasta Casserole es tan deliciosa y casi tan fácil como tu mac y queso tradicionales! ¿La diferencia? Un toque adicional de vegetales nutritivos mezclados en una variedad de quesos fundidos. ¡Atrévete a servir a tu familia algo diferente!",
          ingredientes:
            "<ul><li>150 gr de harina de trigo.</li><li>1 cucharada sopera de azúcar.</li><li>8 gr de levadura en polvo o impulsor químico (aproximadamente una cucharada sopera).</li><li>1 pizca de sal.</li><li>200 ml de leche (1 vaso).</li><li>1 huevo.</li><li>1 cucharadita de postre de mantequilla.</li></ul>",
          img: require("../../assets/menus/dinners/dinners_9.jpg"),
          icon: "school",
          star: 3.7,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 10,
          name: "Huevos revueltos con bacon",
          desc_min:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          desc_max:
            "Un desayuno al más puro estilo inglés, de esos que puedes permitirte los fines de semana y que hacen que empieces el día con una sonrisa y mucha energía. Me encanta preparar huevos revueltos con bacon, y acompañarlos con unas tostaditas de pan con cereales y zumo de naranja recién exprimido. La única “complicación” de esta receta es que da la sensación de que deberías hacerlo todo a la vez: los huevos para que se mantengan jugosos y calientes, el bacon crujiente y el zumo recién exprimido, pero bueno, iremos paso a paso.",
          ingredientes:
            "<ul><li>3 huevos frescos tamaño L.</li><li>2 cucharadas soperas de leche.</li><li>Aceite de semillas y sal.</li><li>4 lonchas de bacon.</li></ul>Para acompañar, tuesta unas rebanadas de tu pan preferido (el mío es de cereales), y exprime unas naranjas.",
          img: require("../../assets/menus/breakfasts/breakfasts_2.jpg"),
          icon: "school",
          star: 3.4,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 11,
          name: "Tortilla de patatas",
          desc_min:
            "Tortilla de patatas o también conocida como tortilla española.",
          desc_max:
            "Hay muchas recetas de la gastronomía española que se conocen de forma internacional pero sin duda la más popular es la tortilla de patatas o también conocida como tortilla española.",
          ingredientes: "",
          img: require("../../assets/menus/breakfasts/breakfasts_3.jpg"),
          icon: "school",
          star: 2.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        },
        {
          fecha: "20-01-2019",
          code: 12,
          name: "Omelette con Espinacas",
          desc_min: "¡Este Omelette con Espinacas seguro te va a encantar!",
          desc_max:
            "PLato para dos, que además es muy fácil de preparar, es una excelente opción para preparar un desayuno rápido y muy saludable. ¡Este Omelette con Espinacas seguro te va a encantar!",
          ingredientes:
            "<ul><li>4 huevos</li><li>2 tajadas de queso</li><li>1 taza de espinacas</li><li>Mantequilla</li><li>Sal</li></ul>",
          img: require("../../assets/menus/breakfasts/breakfasts_4.jpg"),
          icon: "school",
          star: 4.3,
          votos: 2.459,
          Comments: [
            {
              fecha: "20-01-2019",
              user: "MrDaza",
              email: "mr.daza@ingenieros.com",
              comments: "Buenos",
              star: 3
            }
          ]
        }
      ]
    };
  },
  components: {
    Item: Item
  }
};

$("li").hover(
  function() {
    $(this).append($("<span> ***</span>"));
  },
  function() {
    $(this)
      .find("span:last")
      .remove();
  }
);

$("li.fade").hover(function() {
  $(this).fadeOut(100);
  $(this).fadeIn(500);
});
</script>


<style scoped lang="css">
.collapsible.popout > li.active {
  margin: 0px 0 !important;
}

.collapsible-header {
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  height: 100px !important;
}

.collapsible-body {
  padding: 0.2rem !important;
}

.menu_01 {
  background-image: url("../../assets/catering/menu_01.jpg") !important;
  background-size: cover;
  filter: grayscale(20%);
}
.menu_02 {
  background-image: url("../../assets/catering/menu_02.jpg") !important;
  background-size: cover;
  filter: grayscale(20%);
}
.menu_03 {
  background-image: url("../../assets/catering/menu_03.jpg") !important;
  background-size: cover;
  filter: grayscale(20%);
}

h4 {
  text-shadow: 3px 3px 5px #f00 !important;
  font-size: 30px !important;
  color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/components/menu/ListMenuToday.vue